import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';

//- old material ui
import {TimePicker} from '@material-ui/pickers';
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import {gridMargin} from "./general";
import FormHelperText from "@material-ui/core/FormHelperText";

export default class FMPTimePicker extends PureComponent {
	render () {

		const {
			label, value, path, onChange,
			error, helpText, md, disabled, contained
		} = this.props;

		const _onChange = date => {
			onChange(moment(date).format('YYYY-MM-DD HH:mm'), path);
		};

		const hasError = !!error;
		const content = (<Grid item xs={12} md={md} style={gridMargin}>
			<FormControl fullWidth={true} error={hasError} disabled={disabled}>
				<TimePicker
					label={label}
					value={value || null}
					format={'h:mm a'}
					onChange={_onChange}
					disabled={disabled}
				/>
				{hasError && <FormHelperText>{error}</FormHelperText>}
				{(helpText && !hasError) && <FormHelperText>{helpText}</FormHelperText>}
			</FormControl>
		</Grid>);

		if (contained) {
			return (
				<Grid spacing={2} container>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FMPTimePicker.propTypes = {
	label : PropTypes.string.isRequired,
	value : PropTypes.string.isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	helpText : PropTypes.string,
	contained : PropTypes.bool,
	disabled : PropTypes.bool,
	md : PropTypes.number,
};

FMPTimePicker.defaultProps = {
	md : 12,
};
